import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import { builderCalculatorNavigation } from "@/static/navigation";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";

  const smallLayoutWidth = 990;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderHouseBorrowHeaderMobile',
  props: {
    estate: {
      type: Object,
      required: true,
    },
  },
  emits: ["calculate"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;

  const showMobileMenu = ref(false);

  const { isDesktop } = useIsDesktop(smallLayoutWidth);

  watch(
    () => showMobileMenu.value,
    (value) => {
      if (value) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    }
  );

  function handleEmit(emitName) {
    emits(emitName);
    showMobileMenu.value = false;
  }

const __returned__ = { props, emits, showMobileMenu, smallLayoutWidth, isDesktop, handleEmit, ref, watch, get builderCalculatorNavigation() { return builderCalculatorNavigation }, get useIsDesktop() { return useIsDesktop }, DropDown }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})